import {ERROR_ALERT_PUSH, ERROR_LIST_CLEAR, INFO_ALERT_PUSH, INFO_LIST_CLEAR} from "../../constant/reducerConstants";

export const errorListPush = error => {
    return {
        type: ERROR_ALERT_PUSH,
        error
    };
};

export const errorListClear = () => {
    return {
        type: ERROR_LIST_CLEAR
    };
};

export const infoAlertPush = message => {
    return {
        type: INFO_ALERT_PUSH,
        info: message
    };
};

export const infoListClear = () => {
    return {
        type: INFO_LIST_CLEAR
    };
};


// WEBPACK FOOTER //
// ./src/state/action/alertActions.js